import { useAuth } from "../auth/AuthContext";

export default function useIsSuperUser() {
  const { isSuperuser } = useAuth();
  return isSuperuser;
}
